<script>
	import { fade } from "svelte/transition";

	export let sources;
	export let version;

	let open = 0;

	function toggle(e) {
		open = !open;
	}
	function close(e) {
		if (e.target.classList.contains("close")) open = false;
	}
</script>

<style>
	
</style>

<!-- svelte-ignore a11y-missing-attribute -->
<a class="button" class:open on:click|preventDefault={toggle}>Sources</a>
{#if open}
	<div class="modal-bg close" on:click={close} in:fade out:fade>
		<div class="modal" in:fade out:fade>
			<div class="xbutton close" on:click={close} />
			<h2>Sources</h2>
			<ul>
				{#each sources as source}
					<li>
						<a href={source.source} target="_blank">
							{source.title}
						</a>
					</li>
				{/each}
			</ul>
			<!-- <small>v{version}</small> -->
			<small class="version">js v{version}</small>
		</div>
	</div>
{/if}
